module.exports = __webpack_public_path__ + "img/language.e072bf69.png";